module.exports = (parcelRequire.load("ernzT")).then(() => parcelRequire('aY0Bg'));